/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Registered_OnInputs */

const th_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ลงทะเบียน ${i?.date}`)
};

const en_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registered ${i?.date}`)
};

const ja_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}に登録`)
};

const zh_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`于 ${i?.date} 报名`)
};

const es_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inscrito el ${i?.date}`)
};

const pt_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inscrito em ${i?.date}`)
};

const id_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terdaftar pada ${i?.date}`)
};

const fr_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inscrit le ${i?.date}`)
};

const tl_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nagrehistro noong ${i?.date}`)
};

const vi_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đăng ký ngày ${i?.date}`)
};

const ko_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} 등록`)
};

const de_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gemeldet am ${i?.date}`)
};

const ru_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Заявка от ${i?.date}`)
};

const tr_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} tarihinde kaydedildi`)
};

const it_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iscritta il ${i?.date}`)
};

const pl_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zgłoszono ${i?.date}`)
};

const uk_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Заявка від ${i?.date}`)
};

const hi_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} को पंजीकृत`)
};

const ar_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`سُجِّل في ${i?.date}`)
};

const ms_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Didaftarkan pada ${i?.date}`)
};

const bn_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}-এ নিবন্ধিত`)
};

const zh_tw2_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`於 ${i?.date} 報名`)
};

const zh_hk2_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`於 ${i?.date} 報名`)
};

const ur_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} کو رجسٹر ہوئی`)
};

const fa_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ثبت‌شده در ${i?.date}`)
};

const sw_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ilisajiliwa ${i?.date}`)
};

const nl_registered_on = /** @type {(inputs: Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ingeschreven op ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Registered {date}" |
*
* @param {Registered_OnInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const registered_on = /** @type {((inputs: Registered_OnInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registered_OnInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_registered_on(inputs)
	if (locale === "ja") return ja_registered_on(inputs)
	if (locale === "zh") return zh_registered_on(inputs)
	if (locale === "es") return es_registered_on(inputs)
	if (locale === "pt") return pt_registered_on(inputs)
	if (locale === "id") return id_registered_on(inputs)
	if (locale === "fr") return fr_registered_on(inputs)
	if (locale === "tl") return tl_registered_on(inputs)
	if (locale === "vi") return vi_registered_on(inputs)
	if (locale === "ko") return ko_registered_on(inputs)
	if (locale === "de") return de_registered_on(inputs)
	if (locale === "ru") return ru_registered_on(inputs)
	if (locale === "tr") return tr_registered_on(inputs)
	if (locale === "it") return it_registered_on(inputs)
	if (locale === "pl") return pl_registered_on(inputs)
	if (locale === "uk") return uk_registered_on(inputs)
	if (locale === "hi") return hi_registered_on(inputs)
	if (locale === "ar") return ar_registered_on(inputs)
	if (locale === "ms") return ms_registered_on(inputs)
	if (locale === "bn") return bn_registered_on(inputs)
	if (locale === "zh-TW") return zh_tw2_registered_on(inputs)
	if (locale === "zh-HK") return zh_hk2_registered_on(inputs)
	if (locale === "ur") return ur_registered_on(inputs)
	if (locale === "fa") return fa_registered_on(inputs)
	if (locale === "sw") return sw_registered_on(inputs)
	if (locale === "nl") return nl_registered_on(inputs)
	return en_registered_on(inputs)
});